import { render, staticRenderFns } from "./ContentDetailPageDialog.vue?vue&type=template&id=96767018&"
import script from "./ContentDetailPageDialog.vue?vue&type=script&lang=js&"
export * from "./ContentDetailPageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetailPageDialog.vue?vue&type=style&index=0&id=96767018&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports